/*
  If you need to detect a gql query initiation
  pass in the query name
  This util will return an action pattern you
  can match against for this query
  Usage:
    const operation = 'DealLeadInvestorsAllocate';
    ...
    export function* sagas() {
      yield takeLatest(init(operation), loadDealAllocateSaga);
    }
*/
export const init = operation => action => (action.operationName === operation && action.type === 'APOLLO_QUERY_INIT');

/*
  Same as above but on query result
  Usage:
    const operation = 'DealLeadInvestorsAllocate';
    ...
    yield take(result(operation));
*/
export const result = operation => action => (action.operationName === operation && (action.type === 'APOLLO_QUERY_RESULT' || action.type === 'APOLLO_QUERY_RESULT_CLIENT'));

/*
  Use in unit tests to simulate a query return.
  Usage:
    expectSaga(saga)
    .dispatch(mockResult(operation))
    .run();
*/
export const mockResult = operation => ({operationName: operation, type: 'APOLLO_QUERY_RESULT'});

export const mutation_init = operation => action => (action.operationName === operation && action.type === 'APOLLO_MUTATION_INIT');
export const mutation_result = operation => action => (action.operationName === operation && action.type === 'APOLLO_MUTATION_RESULT');
export const mutation_error = operation => action => (action.operationName === operation && action.type === 'APOLLO_MUTATION_ERROR');
export const mockMutationInit = operation => ({operationName: operation, type: 'APOLLO_MUTATION_INIT'});
export const mockMutationResult = operation => ({operationName: operation, type: 'APOLLO_MUTATION_RESULT'});



// WEBPACK FOOTER //
// ./mobile/shared/utils/graphql.js